import React, { useContext } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import LeadsStatusesDatabaseContext from '@/modules/leads_statuses/contexts/LeadsStatusesDatabaseContext';
import RegExpField from '@/modules/common/components/RegExpField';
import DateRangeField from '@/modules/common/components/DateRangeField';
import AutocompleteMultilineField from '@/modules/common/components/AutocompleteMultilineField';

const Component = () => {
    // noinspection JSCheckFunctionSignatures
    const leadsStatusesDatabaseContext = useContext(LeadsStatusesDatabaseContext);
    const valuesFilter = leadsStatusesDatabaseContext.valuesFilter;
    const setValuesFilter = leadsStatusesDatabaseContext.setValuesFilter;
    const offers = leadsStatusesDatabaseContext.offers;
    const vacancies = leadsStatusesDatabaseContext.vacancies;
    const statuses1 = leadsStatusesDatabaseContext.statuses1;
    const statuses2 = leadsStatusesDatabaseContext.statuses2;
    const statuses3 = leadsStatusesDatabaseContext.statuses3;

    return (
        <TableHead>
            <TableRow>
                <TableCell className="adv_sub">ID заявки</TableCell>
                <TableCell className="offer">Оффер</TableCell>
                <TableCell className="datetime_lead">Дата/Время лида</TableCell>
                <TableCell className="vacancy">Вакансия</TableCell>
                <TableCell className="city">Город</TableCell>
                <TableCell className="status1">Статус 1</TableCell>
                <TableCell className="status2">Статус 2</TableCell>
                <TableCell className="status3">Статус 3</TableCell>
                <TableCell className="datetime">Дата/Время</TableCell>
            </TableRow>
            <TableRow className="table-row-filter">
                <TableCell className="adv_sub">
                    <RegExpField value={valuesFilter.advSub}
                                 onChange={(event) => setValuesFilter({...valuesFilter, advSub: event.target.value})}
                                 inputProps={{form: 'form-filter'}}
                    />
                </TableCell>
                <TableCell className="offer">
                    <AutocompleteMultilineField options={offers.map((offer) => offer.offer_name)}
                                                value={valuesFilter.offerName}
                                                setValue={(value) => setValuesFilter({...valuesFilter, offerName: value})}
                    />
                </TableCell>
                <TableCell className="datetime_lead">
                    <DateRangeField value={valuesFilter.dateLead}
                                    setValue={(value) => setValuesFilter({...valuesFilter, dateLead: value})}
                    />
                </TableCell>
                <TableCell className="vacancy">
                    <AutocompleteMultilineField options={vacancies}
                                                value={valuesFilter.vacancy}
                                                setValue={(value) => setValuesFilter({...valuesFilter, vacancy: value})}
                    />
                </TableCell>
                <TableCell className="city">
                    <RegExpField value={valuesFilter.city}
                                 onChange={(event) => setValuesFilter({...valuesFilter, city: event.target.value})}
                                 inputProps={{form: 'form-filter'}}
                    />
                </TableCell>
                <TableCell className="status1">
                    <AutocompleteMultilineField options={statuses1}
                                                value={valuesFilter.status1}
                                                setValue={(value) => setValuesFilter({...valuesFilter, status1: value})}
                    />
                </TableCell>
                <TableCell className="status2">
                    <AutocompleteMultilineField options={statuses2}
                                                value={valuesFilter.status2}
                                                setValue={(value) => setValuesFilter({...valuesFilter, status2: value})}
                    />
                </TableCell>
                <TableCell className="status3">
                    <AutocompleteMultilineField options={statuses3}
                                                value={valuesFilter.status3}
                                                setValue={(value) => setValuesFilter({...valuesFilter, status3: value})}
                    />
                </TableCell>
                <TableCell className="datetime">
                    <DateRangeField value={valuesFilter.date}
                                    setValue={(value) => setValuesFilter({...valuesFilter, date: value})}
                    />
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default Component;
